import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
  CircularProgress,
} from '@mui/material';
import axios from '../api/axios';

// Полный URL для изображения
const getFullImageSrc = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  
  // Если путь начинается с /uploads, используем его как есть (относительный путь)
  if (url.startsWith('/uploads')) {
    return url;
  }
  
  // Если путь начинается с uploads без слеша, добавляем слеш
  if (url.startsWith('uploads')) {
    return '/' + url;
  }
  
  // Если путь начинается с /, используем как есть
  if (url.startsWith('/')) {
    return url;
  }
  
  // Иначе возвращаем как есть
  return url;
};

const SpecialistsSection = () => {
  const [specialists, setSpecialists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSpecialists();
  }, []);

  const fetchSpecialists = async () => {
    try {
      const response = await axios.get('/specialists');
      setSpecialists(response.data);
    } catch (error) {
      console.error('Ошибка загрузки специалистов:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box id="specialists" sx={{ py: 8, backgroundColor: 'white' }}>
      <Container maxWidth="xl">
       

        <Grid container spacing={4}>
          {specialists.length === 0 ? (
            <Grid item xs={12}>
              <Typography align="center" color="text.secondary">
                Информация о специалистах будет добавлена позже
              </Typography>
            </Grid>
          ) : (
            specialists.map((specialist) => (
              <Grid item xs={12} sm={6} md={4} key={specialist._id}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                    },
                  }}
                >
                  <CardMedia
                    component="div"
                    sx={{
                      pt: '56.25%',
                      backgroundColor: 'grey.200',
                      backgroundImage: specialist.photo
                        ? `url("${getFullImageSrc(specialist.photo)}")`
                        : 'none',
                      backgroundSize: '50%',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }}
                    onError={(e) => {
                      console.error('Ошибка загрузки фото специалиста:', specialist.photo);
                    }}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h5" gutterBottom fontWeight={600}>
                      {specialist.name}
                    </Typography>
                    <Chip
                      label={specialist.position}
                      color="primary"
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    {specialist.specialization && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                      >
                        <strong>Специализация:</strong> {specialist.specialization}
                      </Typography>
                    )}
                    {specialist.bio && (
                      <Typography variant="body2" color="text.secondary">
                        {specialist.bio}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default SpecialistsSection;
